import type { PeekItem } from "@/components/peek/notification-peek-context";

/**
 * Schema-snapshot helpers for the peek pane. Both the connector page ("What it
 * can bring in" / "What agents can do") and the connection page ("What it
 * brings in") render schema previews from these — one shape, one renderer.
 */

export interface FeedSchemaEntry {
	name?: string;
	description?: string;
	configSchema?: Record<string, unknown>;
	eventKinds?: Record<
		string,
		{ description?: string; metadataSchema?: Record<string, unknown> }
	>;
}

export interface ActionSchemaEntry {
	name?: string;
	description?: string;
	inputSchema?: Record<string, unknown>;
	outputSchema?: Record<string, unknown>;
}

type SchemaSections = NonNullable<PeekItem["schemaSections"]>;

/** Feed → peek payload: configuration section, then one section per event kind. */
export function feedSchemaSections(feed: FeedSchemaEntry): SchemaSections {
	const sections: SchemaSections["sections"] = [];
	if (feed.configSchema) {
		sections.push({ title: "Configuration", schema: feed.configSchema });
	}
	for (const [kind, kindDef] of Object.entries(feed.eventKinds ?? {})) {
		if (kindDef.metadataSchema) {
			sections.push({
				title: kind,
				description: kindDef.description,
				schema: kindDef.metadataSchema,
			});
		}
	}
	return { description: feed.description, sections };
}

/** Action → peek payload: input section, then output section when declared. */
export function actionSchemaSections(action: ActionSchemaEntry): SchemaSections {
	const sections: SchemaSections["sections"] = [];
	if (action.inputSchema) {
		sections.push({ title: "Input", schema: action.inputSchema });
	}
	if (action.outputSchema) {
		sections.push({ title: "Output", schema: action.outputSchema });
	}
	return { description: action.description, sections };
}
